import { render, staticRenderFns } from "./TaskBackdateExecutionForm.vue?vue&type=template&id=676e2d94&"
import script from "./TaskBackdateExecutionForm.vue?vue&type=script&lang=js&"
export * from "./TaskBackdateExecutionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QInput,QBtn,QSeparator,QCardActions,QSpace} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QInput,QBtn,QSeparator,QCardActions,QSpace}, component.options.components || {})
